#import "../fragments/stageset-fragment.graphql"
#import "../fragments/entity-attribute-enum-fragment.graphql"

query GetCustomFieldById($id: ID!) {
    customField(id: $id) {
        id
        attribute {
            name
            type
            description
        }
        stagesets {
            ...StagesetFragment
        }
        ... on EntityAttributeEnum {
            ...EntityAttributeEnumFragment
        }
    }
}
